globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

/* All modules are implemented in /commons/modules */
appCustomerSpace.Modules.initModules = function($html) {
  $html = $html || $('body');

  appCustomerSpace.Modules.InputClearable.init($html);
  appCustomerSpace.Modules.TableRowsSelectable.init($html);
  appCustomerSpace.Modules.TableSeeMore.init($html);
  appCustomerSpace.Modules.ButtonCollapsable.init($html);
  appCustomerSpace.Modules.PasswordField.init($html);
  appCustomerSpace.Modules.InputCharactersCount.init($html);
  appCustomerSpace.Modules.SeeFullText.init($html);
  appCustomerSpace.Modules.InputButtons.init($html);
  appCustomerSpace.Modules.Counter.init($html);
  appCustomerSpace.Modules.FormValueTrigger.init($html);
  appCustomerSpace.Modules.ResizeTextAreaToFitContent.init($html);
  appCustomerSpace.Modules.InputPhone.init($html);
  appCustomerSpace.Modules.CheckAll.init($html);
  appCustomerSpace.Modules.InputAccountsMediaAbstractFile.init($html);
  appCustomerSpace.Modules.AceEditor.init($html);
}
